<template>
  <TransitionRoot appear :show="showMenu" as="template" v-if="showMenu">
    <TransitionChild
      as="template"
      enter="duration-300 ease-out"
      enter-from="opacity-0"
      enter-to="opacity-10"
      leave="duration-200 ease-in"
      leave-from="opacity-10"
      leave-to="opacity-0"
    >
      <Dialog as="div">
        <DialogOverlay
          class="fixed inset-0 bg-black opacity-30"
          @click="closeMenu"
        />
      </Dialog>
    </TransitionChild>
  </TransitionRoot>
  <div
    class="sidebar bg-white shadow-md fixed inset-y-0 top-0 left-0 transform transition duration-200 ease-in-out z-10 h-screen w-1/3 overflow-y-scroll bg-brand-light-gray"
    :class="[showMenu ? 'translate-x-20' : '-translate-x-full']"
    ref="menu"
  >
    <div class="flex flex-col justify-between h-full">
      <div class="flex flex-col">
        <div class="flex flex-row justify-between bg-white py-3 px-5 shadow-sm">
          <div class="flex items-center">
            <h4>Notification Center</h4>
          </div>
          <div
            @click="closeMenu"
            class="flex justify-end items-center cursor-pointer"
          >
            <XIcon class="text-brand-dark-gray w-7 h-7" />
          </div>
        </div>

        <NotificationList />
      </div>
    </div>
  </div>
</template>
<script>
import { XIcon } from "@heroicons/vue/outline"

import NotificationList from "./components/NotificationList.vue"

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay
} from "@headlessui/vue"

export default {
  components: {
    XIcon,
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    NotificationList
  },
  props: {
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close"],
  data() {
    return {}
  },
  methods: {
    closeMenu() {
      this.$emit("close")
    }
  }
}
</script>
